export default __webpack_public_path__ + "static/media/green_terraform.b68edf1e.svg";